/** @jsxImportSource @emotion/react */

import { FC } from "react";
import { useUIStore } from "../../../../hooks/useUIStore";
import { getThemeColorFromAlias, theme } from "../../../../theme";

interface MapProps {
  state: string;
  height?: number;
}

const StateMap: FC<MapProps> = ({ state, height }) => {
  const { documentColor } = useUIStore();
  const color = getThemeColorFromAlias(documentColor, theme.colors);

  return (
    <svg
      height={height || "160"}
      viewBox="0 0 531 529"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="mapa">
        <path
          id="border"
          opacity="0.66"
          d="M180.877 2.99917L186.691 2L185.691 8.81253L191.506 13.7176L193.413 19.5309L189.507 28.251L188.508 36.971L192.414 48.5977L201.135 54.4111L212.764 52.5036L227.39 45.6911L243.924 48.5977L242.016 40.786L251.737 38.8785L254.644 35.9718L266.272 42.7844L274.085 40.8769L284.805 41.876L292.618 33.156L293.617 26.3435L304.428 15.7159L313.149 25.4351L314.148 38.061L319.962 49.6877L326.776 52.5944L320.962 63.3128L311.241 73.032L307.335 77.937L308.334 86.6571H314.148L318.055 75.0304H330.682L345.309 76.0295V82.8421L342.401 89.6546L335.588 94.5596L345.309 92.6521L350.214 83.9321L360.934 82.0246L384.282 90.7446L390.096 96.558L396.909 94.6505L400.816 102.462V109.275L403.723 112.181L414.443 108.276L426.071 112.181L441.606 116.087L459.139 115.088L479.58 128.713L489.3 137.433L501.928 147.152L518.462 152.057L526.093 162.503L529 179.035L525.094 196.566L511.467 212.099L502.745 220.819L491.117 234.444L482.396 249.068L472.675 252.974L466.861 260.785L467.86 271.504V286.128L464.953 303.659L460.048 319.192L452.235 330.818L453.234 340.538L442.514 353.163L434.701 364.79V374.509L423.073 380.323L420.166 384.229V386.136L410.445 387.135L396.818 384.229L390.005 388.134L383.192 389.134L377.377 393.039L374.47 396.945H366.657L352.031 407.664L344.218 415.475L336.406 420.38L333.499 434.005L335.406 443.725L332.499 456.351L322.779 466.07L315.965 479.695L303.337 499.133L292.618 504.947L284.805 516.573L279.899 526.293L274.993 527.292L273.086 518.572L278.9 512.758L273.086 506.945L269.179 503.039L253.645 493.32L251.737 487.507L245.923 491.412L236.293 479.422H228.48L231.387 473.609L246.013 457.077L262.547 443.452L271.269 437.639L273.177 425.013L269.27 418.2L262.457 416.293L266.363 401.669L262.457 392.949L252.736 395.855L247.83 373.51L237.11 370.604L220.576 371.603L221.757 355.979L216.852 342.354L224.665 319.01L220.758 309.291L212.945 303.477V292.759H188.599L184.692 278.135L187.599 275.228L185.691 261.603C185.691 261.603 175.971 254.79 174.063 254.79C172.155 254.79 154.622 250.885 154.622 250.885L142.994 241.165C142.994 241.165 137.179 244.072 133.273 242.165C129.367 240.257 118.647 226.632 118.647 226.632V206.194L100.205 211.099L91.4837 221.818H82.7625L74.0412 229.629L58.5065 226.723L53.6008 228.63L47.7866 222.817L48.7859 207.284L40.9731 215.096H27.3461L25.4384 208.284L14.6276 207.194L17.5347 201.38L2 182.85L4.90709 173.131L14.6276 169.225L12.7199 162.412L14.6276 149.787L39.883 135.253L51.5113 138.16L62.2312 94.378L58.3248 83.6596L50.6028 79.8445L52.5106 70.1253L64.1389 68.2178L60.2325 62.4045H55.5085V55.5919L77.8567 49.7786L80.7638 54.6836L88.5766 46.8719L93.4823 57.5903L102.204 64.4028L114.831 61.4961L133.273 52.7761L141.994 44.9644L138.088 40.0594L129.367 28.4326L124.552 17.6234L137.179 21.5293L148.808 24.4359L155.621 16.6242L171.156 11.7192L180.877 2.99917Z"
          stroke={color}
          strokeWidth="2"
        />
        {state === "PI" && (
          <g id="PI">
            <path
              id="Vector"
              d="M404 171L422 188"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_2"
              d="M404 188L422 171"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_3"
              d="M413 187C417.418 187 421 183.418 421 179C421 174.582 417.418 171 413 171C408.582 171 405 174.582 405 179C405 183.418 408.582 187 413 187Z"
              fill={color}
            />
          </g>
        )}
        {state === "PA" && (
          <g id="PA">
            <path
              id="Vector_4"
              d="M277 133L295 150"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_5"
              d="M277 150L295 133"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_6"
              d="M286 149C290.418 149 294 145.418 294 141C294 136.582 290.418 133 286 133C281.582 133 278 136.582 278 141C278 145.418 281.582 149 286 149Z"
              fill={color}
            />
          </g>
        )}
        {state === "ES" && (
          <g id="ES">
            <path
              id="Vector_7"
              d="M431 325L449 342"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_8"
              d="M431 342L449 325"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_9"
              d="M440 341C444.418 341 448 337.418 448 333C448 328.582 444.418 325 440 325C435.582 325 432 328.582 432 333C432 337.418 435.582 341 440 341Z"
              fill={color}
            />
          </g>
        )}
        {state === "RS" && (
          <g id="RS">
            <path
              id="Vector"
              d="M271.052 464.94L286.426 479.46"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_2"
              d="M271.052 479.46L286.426 464.94"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_3"
              d="M278.739 478.606C282.513 478.606 285.572 475.547 285.572 471.773C285.572 467.999 282.513 464.94 278.739 464.94C274.965 464.94 271.906 467.999 271.906 471.773C271.906 475.547 274.965 478.606 278.739 478.606Z"
              fill={color}
            />
          </g>
        )}
        {state === "MS" && (
          <g id="MS">
            <path
              id="Vector_4"
              d="M249.698 345.361L265.073 359.882"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_5"
              d="M249.698 359.882L265.073 345.361"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_6"
              d="M257.386 359.028C261.159 359.028 264.219 355.968 264.219 352.195C264.219 348.421 261.159 345.361 257.386 345.361C253.612 345.361 250.553 348.421 250.553 352.195C250.553 355.968 253.612 359.028 257.386 359.028Z"
              fill={color}
            />
          </g>
        )}
        {state === "MG" && (
          <g id="MG">
            <path
              id="Vector_7"
              d="M382.089 320.592L397.464 335.112"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_8"
              d="M382.089 335.112L397.464 320.592"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_9"
              d="M389.776 334.258C393.55 334.258 396.609 331.198 396.609 327.425C396.609 323.651 393.55 320.592 389.776 320.592C386.003 320.592 382.943 323.651 382.943 327.425C382.943 331.198 386.003 334.258 389.776 334.258Z"
              fill={color}
            />
          </g>
        )}
        {state === "RJ" && (
          <g id="RJ">
            <path
              id="Vector_10"
              d="M406.859 369.277L422.233 383.797"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_11"
              d="M406.859 383.797L422.233 369.277"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_12"
              d="M414.546 382.943C418.32 382.943 421.379 379.884 421.379 376.11C421.379 372.336 418.32 369.277 414.546 369.277C410.772 369.277 407.713 372.336 407.713 376.11C407.713 379.884 410.772 382.943 414.546 382.943Z"
              fill={color}
            />
          </g>
        )}
        {state === "GO" && (
          <g id="GO">
            <path
              id="Vector_13"
              d="M310.342 288.135L325.716 302.655"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_14"
              d="M310.342 302.655L325.716 288.135"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_15"
              d="M318.029 301.801C321.803 301.801 324.862 298.741 324.862 294.968C324.862 291.194 321.803 288.135 318.029 288.135C314.255 288.135 311.196 291.194 311.196 294.968C311.196 298.741 314.255 301.801 318.029 301.801Z"
              fill={color}
            />
          </g>
        )}
        {state === "MT" && (
          <g id="MT">
            <path
              id="Vector_16"
              d="M235.178 242.011L250.553 256.532"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_17"
              d="M235.178 256.532L250.553 242.011"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_18"
              d="M242.865 255.677C246.639 255.677 249.698 252.618 249.698 248.844C249.698 245.071 246.639 242.011 242.865 242.011C239.092 242.011 236.032 245.071 236.032 248.844C236.032 252.618 239.092 255.677 242.865 255.677Z"
              fill={color}
            />
          </g>
        )}
        {state === "SP" && (
          <g id="SP">
            <path
              id="Vector_19"
              d="M335.966 370.985L351.34 385.506"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_20"
              d="M335.966 385.506L351.34 370.985"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_21"
              d="M343.653 384.652C347.427 384.652 350.486 381.592 350.486 377.818C350.486 374.045 347.427 370.985 343.653 370.985C339.879 370.985 336.82 374.045 336.82 377.818C336.82 381.592 339.879 384.652 343.653 384.652Z"
              fill={color}
            />
          </g>
        )}
        {state === "PR" && (
          <g id="PR">
            <path
              id="Vector_22"
              d="M292.405 399.172L307.78 413.692"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_23"
              d="M292.405 413.692L307.78 399.172"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_24"
              d="M300.092 412.838C303.866 412.838 306.925 409.779 306.925 406.005C306.925 402.231 303.866 399.172 300.092 399.172C296.319 399.172 293.259 402.231 293.259 406.005C293.259 409.779 296.319 412.838 300.092 412.838Z"
              fill={color}
            />
          </g>
        )}
        {state === "SC" && (
          <g id="SC">
            <path
              id="Vector_25"
              d="M310.342 438.462L325.716 452.982"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_26"
              d="M310.342 452.982L325.716 438.462"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_27"
              d="M318.029 452.128C321.803 452.128 324.862 449.069 324.862 445.295C324.862 441.521 321.803 438.462 318.029 438.462C314.255 438.462 311.196 441.521 311.196 445.295C311.196 449.069 314.255 452.128 318.029 452.128Z"
              fill={color}
            />
          </g>
        )}
        {state === "BA" && (
          <g id="BA">
            <path
              id="Vector_37"
              d="M413 242L431 259"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_38"
              d="M413 259L431 242"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_39"
              d="M422 258C426.418 258 430 254.418 430 250C430 245.582 426.418 242 422 242C417.582 242 414 245.582 414 250C414 254.418 417.582 258 422 258Z"
              fill={color}
            />
          </g>
        )}
        {state === "AM" && (
          <g id="AM">
            <path
              id="Vector_40"
              d="M129 133L147 150"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_41"
              d="M129 150L147 133"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_42"
              d="M138 149C142.418 149 146 145.418 146 141C146 136.582 142.418 133 138 133C133.582 133 130 136.582 130 141C130 145.418 133.582 149 138 149Z"
              fill={color}
            />
          </g>
        )}
        {state === "AC" && (
          <g id="AC">
            <path
              id="Vector_43"
              d="M46 188L64 205"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_44"
              d="M46 205L64 188"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_45"
              d="M55 204C59.4183 204 63 200.418 63 196C63 191.582 59.4183 188 55 188C50.5817 188 47 191.582 47 196C47 200.418 50.5817 204 55 204Z"
              fill={color}
            />
          </g>
        )}
        {state === "RO" && (
          <g id="RO">
            <path
              id="Vector_46"
              d="M147 214L165 231"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_47"
              d="M147 231L165 214"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_48"
              d="M156 230C160.418 230 164 226.418 164 222C164 217.582 160.418 214 156 214C151.582 214 148 217.582 148 222C148 226.418 151.582 230 156 230Z"
              fill={color}
            />
          </g>
        )}
        {state === "AP" && (
          <g id="AP">
            <path
              id="Vector_49"
              d="M286 56L304 73"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_50"
              d="M286 73L304 56"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_51"
              d="M295 72C299.418 72 303 68.4183 303 64C303 59.5817 299.418 56 295 56C290.582 56 287 59.5817 287 64C287 68.4183 290.582 72 295 72Z"
              fill={color}
            />
          </g>
        )}
        {state === "RR" && (
          <g id="RR">
            <path
              id="Vector_52"
              d="M165 39L183 56"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_53"
              d="M165 56L183 39"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_54"
              d="M174 55C178.418 55 182 51.4183 182 47C182 42.5817 178.418 39 174 39C169.582 39 166 42.5817 166 47C166 51.4183 169.582 55 174 55Z"
              fill={color}
            />
          </g>
        )}
        {state === "MA" && (
          <g id="MA">
            <path
              id="Vector_55"
              d="M372 133L390 150"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_56"
              d="M372 150L390 133"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_57"
              d="M381 149C385.418 149 389 145.418 389 141C389 136.582 385.418 133 381 133C376.582 133 373 136.582 373 141C373 145.418 376.582 149 381 149Z"
              fill={color}
            />
          </g>
        )}
        {state === "TO" && (
          <g id="TO">
            <path
              id="Vector_58"
              d="M333 205L351 222"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_59"
              d="M333 222L351 205"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_60"
              d="M342 221C346.418 221 350 217.418 350 213C350 208.582 346.418 205 342 205C337.582 205 334 208.582 334 213C334 217.418 337.582 221 342 221Z"
              fill={color}
            />
          </g>
        )}
        {state === "SE" && (
          <g id="SE">
            <path
              id="Vector_61"
              d="M474 205L492 222"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_62"
              d="M474 222L492 205"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_63"
              d="M483 221C487.418 221 491 217.418 491 213C491 208.582 487.418 205 483 205C478.582 205 475 208.582 475 213C475 217.418 478.582 221 483 221Z"
              fill={color}
            />
          </g>
        )}
        {state === "AL" && (
          <g id="AL">
            <path
              id="Vector_64"
              d="M487 193L505 210"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_65"
              d="M487 210L505 193"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_66"
              d="M496 209C500.418 209 504 205.418 504 201C504 196.582 500.418 193 496 193C491.582 193 488 196.582 488 201C488 205.418 491.582 209 496 209Z"
              fill={color}
            />
          </g>
        )}
        {state === "PE" && (
          <g id="PE">
            <path
              id="Vector_67"
              d="M496 179L514 196"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_68"
              d="M496 196L514 179"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_69"
              d="M505 195C509.418 195 513 191.418 513 187C513 182.582 509.418 179 505 179C500.582 179 497 182.582 497 187C497 191.418 500.582 195 505 195Z"
              fill={color}
            />
          </g>
        )}
        {state === "CE" && (
          <g id="CE">
            <path
              id="Vector_70"
              d="M447 131L465 148"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_71"
              d="M447 148L465 131"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_72"
              d="M456 147C460.418 147 464 143.418 464 139C464 134.582 460.418 131 456 131C451.582 131 448 134.582 448 139C448 143.418 451.582 147 456 147Z"
              fill={color}
            />
          </g>
        )}
        {state === "RN" && (
          <g id="RN">
            <path
              id="Vector_73"
              d="M490 144L508 161"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_74"
              d="M490 161L508 144"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_75"
              d="M499 160C503.418 160 507 156.418 507 152C507 147.582 503.418 144 499 144C494.582 144 491 147.582 491 152C491 156.418 494.582 160 499 160Z"
              fill={color}
            />
          </g>
        )}
        {state === "PB" && (
          <g id="PB">
            <path
              id="Vector_76"
              d="M496 163L514 180"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_77"
              d="M496 180L514 163"
              stroke="#D804B6"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              id="Vector_78"
              d="M505 179C509.418 179 513 175.418 513 171C513 166.582 509.418 163 505 163C500.582 163 497 166.582 497 171C497 175.418 500.582 179 505 179Z"
              fill={color}
            />
          </g>
        )}
      </g>
    </svg>
  );
};

export default StateMap;
